/*
src/ui-misc/ImagesList.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-14
*/


import * as React from 'react';

import {HTMLTable, Radio, Button} from '@blueprintjs/core';


/*

props (required):
	bank				- an SDImageBank instance

props (optional):
	selected		- selected image, or null
	onSelect		- function(image)

If onSelect is not a function then the left-most selection column with radio buttons will not be displayed.

*/


export class ImagesList extends React.Component {


	constructor(props) {
		super(props);

		this.needsRender = this.needsRender.bind(this);
		this.onDeleteImage = this.onDeleteImage.bind(this);
		this.onAddImagesFromFiles = this.onAddImagesFromFiles.bind(this);

		this.props.bank.registerCallback('change', this.needsRender);

		this.state = {
			dirtyCount: 1,
		};
	}


	needsRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	onDeleteImage(image) {
		this.props.bank.deleteImage(image);
	}

	onAddImagesFromFiles(files) {
		for (let i = 0; i < files.length; ++i) {
			this.props.bank.addNewImageFromFile(files[i]);
		}
	}


	render() {
	
		let selectable = typeof this.props.onSelect === 'function';

		let headItems = [];
		if (selectable) {
			headItems.push((
				<tr key="header">
					<td>Selected</td>
					<td>Image</td>
					<td>Name</td>
					<td>Actions</td>
				</tr>
			));
		} else {
			headItems.push((
				<tr key="header">
					<td>Image</td>
					<td>Name</td>
					<td>Actions</td>
				</tr>
			));
		}

		let images = this.props.bank.getImages();

		let items = [];
		for (let i = 0; i < images.length; ++i) {

			let image = images[i];

			let thumb;
			let src = image.getSrc();
			if (src === '') {
				thumb = (<div style={{display: "block", width: "80px", height: "120px", margin: "0", padding: "0"}}></div>);
			} else {
				thumb = (<img src={src} alt="" style={{display: "block", maxWidth: "120px", height: "80px", margin: "0", padding: "0"}} />);
			}

			let actions = [];
			if (!image.getIsLocked()) {
				actions.push(<Button icon="delete" disabled={!image.getCanDelete()} onClick={() => this.onDeleteImage(image)} >Delete</Button>);
			}

			if (selectable) {
				items.push((
					<tr key={image.getId()}>
						<td style={{verticalAlign: "middle", textAlign: "center"}}>
							<Radio onChange={() => this.props.onSelect(image)} checked={image === this.props.selected} />	
						</td>
						<td style={{verticalAlign: "middle"}}>
							{thumb}
						</td>
						<td style={{verticalAlign: "middle"}}>
							{image.getName()}
						</td>
						<td style={{verticalAlign: "middle"}}>
							{actions}
						</td>
					</tr>
				));
			} else {
				items.push((
					<tr key={image.getId()}>
						<td style={{verticalAlign: "middle"}}>
							{thumb}
						</td>
						<td style={{verticalAlign: "middle"}}>
							{image.getName()}
						</td>
						<td style={{verticalAlign: "middle"}}>
							{actions}
						</td>
					</tr>
				));
			}
		}

		// File input styling technique below from (6/13/19):
		//	http://geniuscarrier.com/how-to-style-a-html-file-upload-button-in-pure-css/

		return (

			<div>

				<Button icon="add" style={{position: "relative", overflow: "hidden", margin: "40px 0"}} >
					<input type="file" accept="image/svg+xml" multiple
          	onChange={e => this.onAddImagesFromFiles(e.target.files)}
          	style={{position: "absolute", top: "0", right: "0", margin: "0", padding: "0", fontSize: "20px", cursor: "pointer", opacity: "0", filter: "alpha(opacity=0)"}} />
					Add Image
				</Button>

				<HTMLTable striped condensed style={{width: "100%"}}>
					<thead>
						{headItems}
					</thead>
					<tbody>
						{items}
					</tbody>
				</HTMLTable>

			</div>
		);
	}

}


